import { Box, Text } from '@factorialco/deprecated-design-system'
import { PlanningBalancesQuery } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import HoursDisplay, { Element, formatDuration } from './HoursDisplay'

type TimePlanningBalance = NonNullable<
  PlanningBalancesQuery['timePlanning']['balancesConnection']['nodes']
>[number]

interface Props {
  balances: TimePlanningBalance
}

const HoursToPlan = ({ balances }: Props) => {
  const formatHours = (hours: number | null | undefined) => formatDuration((hours ?? 0) * 3600000)
  const formatHoursWithMinus = (hours: number) => {
    return hours === 0 ? formatHours(hours) : `- ${formatHours(hours)}`
  }

  const { contractHours = 0, leaveHours = 0, bankHolidayHours = 0 } = balances

  // Fix floating-point precision errors by rounding to 2 decimal places
  // e.g., 31 - 24.8 - 6.2 = -8.881784197001252e-16 instead of 0
  const totalHours = Number(
    ((contractHours ?? 0) - (leaveHours ?? 0) - (bankHolidayHours ?? 0)).toFixed(2)
  )

  const formattedContractHours = formatHours(contractHours)
  const formattedLeaveHours = formatHoursWithMinus(leaveHours ?? 0)
  const formattedBankHolidayHours = formatHoursWithMinus(bankHolidayHours ?? 0)
  const formattedTotalHours = formatHours(totalHours)

  return (
    <HoursDisplay
      title={i18n.t('shift_management.hours_information.hours_to_plan')}
      totalDuration={formattedTotalHours}
      triggerColor="grey800"
    >
      <Box flexDirection="row" justifyContent="spaceBetween">
        <Text size="100" weight="medium" color="grey1000">
          {i18n.t('shift_management.hours_information.agreement_hours')}
        </Text>
        <Text size="100" weight="medium" color="grey1000">
          {formattedContractHours}
        </Text>
      </Box>

      <Element
        title={i18n.t('shift_management.hours_information.approved_leaves')}
        value={formattedLeaveHours}
      />
      <Element
        title={i18n.t('shift_management.hours_information.bank_holidays')}
        value={formattedBankHolidayHours}
      />
    </HoursDisplay>
  )
}

export default HoursToPlan
